import { default as VeneerCard } from '@veneer/core/dist/esm/scripts/card'
import classes from './Card.module.scss'
import React from 'react'

const Card = ({ content, children, appearance, className }) => {
  return (
    <div className={classes.container}>
      <VeneerCard
        appearance={appearance}
        className={`${classes.card} ${className}`}
        content={content}
      />
      {children}
    </div>
  )
}

export default Card
